import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { SeoService } from './seo.service';

/**
 * Gates the AI Visibility (GEO) screen. GEO is its own super-admin opt-in on top
 * of SEO, so this requires the company to have SEO enabled + onboarded AND the GEO
 * add-on switched on. Otherwise bounce to the SEO dashboard.
 */
export const geoAccessGuard: CanActivateFn = () => {
    const seo = inject(SeoService);
    const router = inject(Router);
    return seo.status().pipe(
        map((s) => {
            if (s?.enabled && s?.onboarded && s?.geoEnabled) return true;
            return router.createUrlTree(['/seo/dashboard']);
        }),
        catchError(() => of(router.createUrlTree(['/seo/dashboard'])))
    );
};
